<template>
<div class="row mt-4 d-flex align-items-center justify-content-end z-index" v-if="pagination.totalResults">
    <div class="col-6 mr-n2 d-flex justify-content-end">
        <p class="mb-0 mr-4 pr-4 border-right">
            {{ minItems }} - {{ maxItems }} de {{ parseInt(pagination.totalResults) }} resultados
        </p>
    </div>
        <Button @click="prev" color="grey" type="outline" icon :disabled="pagination.thisPage == 1">
            <PrevPage :disabled="pagination.thisPage == 1"/>
        </Button>
        <Button @click="next" color="grey" class="mr-3 ml-3" type="outline" icon :disabled="pagination.totalPages == pagination.thisPage">
            <NextPage :disabled="pagination.totalPages == pagination.thisPage"/>
        </Button>
</div>
</template>

<script>
import PrevPage from "@/components/icons/PrevPage"
import NextPage from "@/components/icons/NextPage"

export default {
    props: {
        pagination: {
            required: true
        },
        multiply: {
            default: 50
        }
    },
    components: {
        PrevPage,
        NextPage
    },
    methods: {
        next() {
            if (parseInt(this.pagination.thisPage) < parseInt(this.pagination.totalPages)) {
                this.$emit('next', parseInt(this.pagination.thisPage) + 1)
            }
        },
        prev() {
            if (parseInt(this.pagination.thisPage) > 1) {
                this.$emit('prev', parseInt(this.pagination.thisPage) - 1)
            }
        }
    },
    computed: {
        minItems() {
            return (( parseInt(this.pagination.thisPage) - 1) * this.multiply ) + 1
        },
        maxItems() {
            const max = ((this.pagination.thisPage - 1) * this.multiply ) + this.multiply 
            const current = parseInt(this.pagination.totalResults)
            
            return current < max ? current : max
        }
    },
}
</script>

<style lang="scss">

</style>

